import { AfterViewChecked, AfterViewInit, Component, ElementRef, input, signal, viewChild } from "@angular/core";
import { isNil } from "lodash";

@Component({
  selector: "app-new-ankaadia-announcement-header",
  templateUrl: "./new-ankaadia-announcement-header.component.svg",
  styleUrl: "./new-ankaadia-announcement-header.component.scss",
})
export class NewAnkaadiaAnnouncementHeaderComponent implements AfterViewInit, AfterViewChecked {
  protected readonly title = input.required<string>();
  protected readonly textContainer = viewChild<ElementRef<SVGRectElement>>("textContainer");
  protected readonly textElement = viewChild<ElementRef<SVGTextElement>>("textElement");
  protected readonly textSpan = viewChild<ElementRef<SVGTSpanElement>>("textSpan");
  protected readonly fontSize = signal(24);

  ngAfterViewInit(): void {
    this.updateHeaderSize();
  }

  ngAfterViewChecked(): void {
    this.updateHeaderSize();
  }

  private updateHeaderSize(): void {
    const textContainer = this.textContainer()?.nativeElement;
    const textElement = this.textElement()?.nativeElement;
    const textSpan = this.textSpan()?.nativeElement;

    if (isNil(textContainer) || isNil(textElement) || isNil(textSpan)) {
      return;
    }

    const baseSize = this.fontSize();

    const textContainerBBox = textContainer.getBBox();
    const textSpanBBox = textElement.getBBox();

    const padding = (textSpanBBox.x - textContainerBBox.x) * 2.0;
    const maxWidth = textContainerBBox.width - padding;

    const factor = maxWidth / textSpanBBox.width;
    const verticalTextSize = textSpanBBox.height * factor;
    const verticalTextPosition = textContainerBBox.height / 2.0 + verticalTextSize / 2.0;

    textSpan.setAttribute("y", String(verticalTextPosition));
    this.fontSize.set(baseSize * factor);
  }
}
